import React from "react";

import { useLocation } from "react-router";

import { ActivationsContext } from "./Context";

type PropsType = {
  children: React.ReactNode;
};

export default function Container({ children }: PropsType) {
  const [appData, setAppData] = React.useContext(ActivationsContext);
  const location = useLocation();

  React.useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    setAppData({
      ...appData,
      params: {
        ...appData.params,
        ...Object.fromEntries(searchParams),
      },
    });
  }, [location]);

  return (
    <div data-testid="activation" className="md:bg-steel-blue-50">
      <div className="mx-4 mt-4 mb-8 flex flex-col md:m-0 md:mx-auto md:max-w-2xl md:p-6">
        {children}
      </div>
    </div>
  );
}
